import "./index.css";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { HOST_URL } from "../utils/Url";
import knn from '../assets/images/qq (1).png'
import data1 from '../assets/images/data.png'
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ToastApp from "../ToastApp";
import { Grid, Button, CircularProgress, Box, Typography, IconProps } from '@mui/material';


function LoginPage() {
  const [isSignUpMode, setIsSignUpMode] = useState<boolean>(false);
  const [userID, setUserID] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);



  const handleSignUpClick = () => {
    setIsSignUpMode(true);
  };

  const handleSignInClick = () => {
    setIsSignUpMode(false);
  };

  let navigate = useNavigate();

  const validationSchema = Yup.object({
    useR_ID: Yup.string().test(
      "required",
      "Username Required",
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    password: Yup.string().test(
      "required",
      "Password Required",
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      useR_ID: "",
      password: "",
      collageID: "1",
      packageID: "1",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await axios.post(
          HOST_URL + `USER/USERLOGIN`,
          values
        );
        if (response.data.isSuccess) {
          localStorage.clear();
          sessionStorage.clear();
          localStorage.setItem("userdata", JSON.stringify(response.data.data));
          localStorage.setItem("useR_ID", JSON.stringify(response.data.data[0]["userdetail"][0]["useR_ID"]));
          sessionStorage.setItem("token", JSON.stringify(response.data.data[0]["token"]));
          toast.success(response.data.mesg);
          formik.resetForm();

          if (values.useR_ID === "admin@visitor") {
            navigate('/visitor-dashboard');
            return;
          }
          navigate(`/home`);
          console.log("Navigation should have occurred.");
        } else {
          toast.error(response.data.mesg);
        }
      }
      catch (error) {
        toast.error("Login Failed");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    // <>
    //   <style>
    //     {`
    //     .shape {
    //       position: absolute;
    //       z-index: 0;
    //       opacity: 0.1;
    //       animation: float 10s ease-in-out infinite;
    //     }

    //     .shape1 {
    //       top: 5%;
    //       left: 2%;
    //       width: 120px;
    //       height: 120px;
    //       background: #6C63FF;
    //       border-radius: 50%;
    //     }

    //     .shape2 {
    //       bottom: 10%;
    //       right: 10%;
    //       width: 140px;
    //       height: 140px;
    //       background: #FF6584;
    //       clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    //     }

    //     .shape3 {
    //       top: 40%;
    //       left: 35%;
    //       width: 100px;
    //       height: 100px;
    //       background: #00BFA6;
    //       transform: rotate(45deg);
    //     }

    //     @keyframes float {
    //       0% { transform: translateY(0); }
    //       50% { transform: translateY(-20px); }
    //       100% { transform: translateY(0); }
    //     }
    //   `}
    //   </style>

    //   <Box
    //     sx={{
    //       position: 'relative',
    //       minHeight: '100vh',
    //       display: 'flex',
    //       alignItems: 'center',
    //       justifyContent: 'center',
    //       background: 'linear-gradient(135deg, #dfe9f3, #ffffff)',
    //       overflow: 'hidden',
    //     }}
    //   >
    //     {/* Floating Background Shapes */}
    //     <div className="shape shape1" />
    //     <div className="shape shape2" />
    //     <div className="shape shape3" />

    //     <Grid
    //       container
    //       spacing={2}
    //       justifyContent="center"
    //       alignItems="center"
    //       sx={{ zIndex: 1, px: 2 }}
    //     >
    //       {/* Illustration */}
    //       <Grid
    //         item
    //         xs={12}
    //         md={6}
    //         sx={{
    //           display: { xs: 'none', md: 'flex' },
    //           justifyContent: 'center',
    //         }}
    //       >
    //         <img
    //           alt="Illustration"
    //           src={data1}
    //           style={{
    //             height: '75vh',
    //             objectFit: 'contain',
    //           }}
    //         />
    //       </Grid>

    //       {/* Login Box */}
    //       <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center' }}>
    //         <Box
    //           sx={{
    //             background: 'rgba(255, 255, 255, 0.9)',
    //             backdropFilter: 'blur(8px)',
    //             borderRadius: 4,
    //             p: 3, // reduced padding
    //             minHeight: '420px', // reduced height
    //             width: { xs: '85%', sm: '75%', md: '360px' }, // fixed width on larger screens
    //             boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
    //             display: 'flex',
    //             flexDirection: 'column',
    //             justifyContent: 'center',
    //           }}
    //         >

    //           <form onSubmit={formik.handleSubmit}>
    //             <Box textAlign="center" mb={2}>
    //               <img
    //                 src={knn}
    //                 alt="Logo"
    //                 style={{ height: '90px', marginBottom: '10px' }}
    //               />
    //               <h2 style={{ fontSize: '24px', fontWeight: 600, color: '#333' }}>
    //                 CSJMU Library Kanpur
    //               </h2>
    //             </Box>

    //             {/* Username */}
    //             <Box
    //               sx={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 backgroundColor: '#fff',
    //                 border: '1px solid #ccc',
    //                 borderRadius: 2,
    //                 px: 2,
    //                 mb: 2,
    //               }}
    //             >
    //               <FontAwesomeIcon icon={faUser} style={{ marginRight: 8 }} />
    //               <input
    //                 className="LoginInput"
    //                 type="text"
    //                 name="useR_ID"
    //                 id="useR_ID"
    //                 placeholder="Username"
    //                 required
    //                 value={formik.values.useR_ID}
    //                 onChange={formik.handleChange}
    //                 style={{
    //                   flex: 1,
    //                   padding: '10px',
    //                   border: 'none',
    //                   outline: 'none',
    //                   fontSize: '16px',
    //                   background: 'transparent',
    //                 }}
    //               />
    //             </Box>

    //             {/* Password */}
    //             <Box
    //               sx={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 backgroundColor: '#fff',
    //                 border: '1px solid #ccc',
    //                 borderRadius: 2,
    //                 px: 2,
    //                 mb: 3,
    //               }}
    //             >
    //               <FontAwesomeIcon icon={faLock} style={{ marginRight: 8 }} />
    //               <input
    //                 className="LoginInput"
    //                 type="password"
    //                 name="password"
    //                 id="password"
    //                 placeholder="Password"
    //                 required
    //                 value={formik.values.password}
    //                 onChange={formik.handleChange}
    //                 style={{
    //                   flex: 1,
    //                   padding: '10px',
    //                   border: 'none',
    //                   outline: 'none',
    //                   fontSize: '16px',
    //                   background: 'transparent',
    //                 }}
    //               />
    //             </Box>

    //             {/* Buttons */}
    //             <Box display="flex" justifyContent="center" gap={2}>
    //               <Button
    //                 variant="contained"
    //                 color="primary"
    //                 type="submit"
    //                 disabled={loading}
    //                 sx={{ px: 4, borderRadius: 2 }}
    //               >
    //                 {loading ? <CircularProgress size={24} /> : 'Login'}
    //               </Button>
    //               <Button
    //                 variant="outlined"
    //                 color="error"
    //                 onClick={() => formik.resetForm()}
    //                 sx={{ px: 4, borderRadius: 2 }}
    //               >
    //                 Reset
    //               </Button>
    //             </Box>
    //           </form>
    //         </Box>
    //       </Grid>
    //     </Grid>

    //     <ToastApp />
    //   </Box>
    // </>


    <>
      <style>
        {`
    .shape {
      position: absolute;
      z-index: 0;
      opacity: 0.15;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
    }

    /* Circle */
    .shape1 {
      top: 5%;
      left: 2%;
      width: 120px;
      height: 120px;
      background: linear-gradient(135deg, #6C63FF, #8E85FF);
      border-radius: 50%;
      animation: float 8s infinite, pulse 4s infinite alternate;
      box-shadow: 0 10px 30px rgba(108, 99, 255, 0.3);
    }

    /* Triangle */
    .shape2 {
      bottom: 10%;
      right: 10%;
      width: 140px;
      height: 140px;
      background: linear-gradient(135deg, #FF6584, #FF8FA3);
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      animation: float 10s infinite reverse, rotate 15s infinite linear;
      box-shadow: 0 10px 30px rgba(255, 101, 132, 0.3);
    }

    /* Square */
    .shape3 {
      top: 40%;
      left: 35%;
      width: 100px;
      height: 100px;
      background: linear-gradient(135deg, #00BFA6, #00E5C9);
      transform: rotate(45deg);
      animation: float 12s infinite, pulse 3s infinite alternate-reverse;
      box-shadow: 0 10px 30px rgba(0, 191, 166, 0.3);
    }

    /* New Diamond Shape */
    .shape4 {
      bottom: 20%;
      left: 15%;
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #FF9A8B, #FF6B95);
      clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
      animation: float 9s infinite reverse, pulse 5s infinite;
      box-shadow: 0 10px 30px rgba(255, 106, 149, 0.3);
    }

    /* New Blob Shape */
    .shape5 {
      top: 15%;
      right: 15%;
      width: 100px;
      height: 100px;
      background: linear-gradient(135deg, #A18CD1, #FBC2EB);
      border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
      animation: float 11s infinite, morph 8s infinite alternate;
      box-shadow: 0 10px 30px rgba(161, 140, 209, 0.3);
    }

    /* New Wave Shape */
    .shape6 {
      bottom: 30%;
      right: 25%;
      width: 150px;
      height: 80px;
      background: linear-gradient(135deg, #4FACFE, #00F2FE);
      clip-path: path('M0,20 C40,40 60,0 100,20 C140,40 160,0 200,20 L200,80 L0,80 Z');
      animation: float 14s infinite, wave 12s infinite alternate;
      box-shadow: 0 10px 30px rgba(79, 172, 254, 0.3);
    }

    @keyframes float {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-25px); }
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }

    @keyframes rotate {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes morph {
      0% { border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%; }
      50% { border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; }
      100% { border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; }
    }

    @keyframes wave {
      0% { clip-path: path('M0,20 C40,40 60,0 100,20 C140,40 160,0 200,20 L200,80 L0,80 Z'); }
      50% { clip-path: path('M0,30 C40,10 60,50 100,30 C140,10 160,50 200,30 L200,80 L0,80 Z'); }
      100% { clip-path: path('M0,10 C40,30 60,10 100,10 C140,30 160,10 200,10 L200,80 L0,80 Z'); }
    }

    /* Subtle background animation */
    @keyframes gradientShift {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `}
      </style>

      <Box
        sx={{
          position: 'relative',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(-45deg, #dfe9f3, #f5f7fa, #e4e8f0, #dfe9f3)',
          backgroundSize: '400% 400%',
          animation: 'gradientShift 15s ease infinite',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.8) 0%, transparent 70%)',
            pointerEvents: 'none',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 80% 70%, rgba(255,255,255,0.6) 0%, transparent 70%)',
            pointerEvents: 'none',
          }
        }}
      >
        {/* Floating Background Shapes */}
        <div className="shape shape1" />
        <div className="shape shape2" />
        <div className="shape shape3" />
        <div className="shape shape4" />
        <div className="shape shape5" />
        <div className="shape shape6" />

        {/* Subtle particle effect */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'radial-gradient(circle at center, rgba(255,255,255,0.3) 1px, transparent 1px)',
            backgroundSize: '20px 20px',
            pointerEvents: 'none',
            opacity: 0.5
          }}
        />

        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{
            zIndex: 1,
            px: 2,
            position: 'relative'
          }}
        >
          {/* Illustration */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              animation: 'fadeIn 1s ease-out',
              position: 'relative'
            }}
          >
            <Box
              sx={{
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: '-20px',
                  left: '-20px',
                  right: '-20px',
                  bottom: '-20px',
                  background: 'linear-gradient(45deg, #6C63FF, #00BFA6)',
                  borderRadius: '20px',
                  zIndex: -1,
                  opacity: 0.2,
                  filter: 'blur(20px)'
                }
              }}
            >
              <img
                alt="Illustration"
                src={data1}
                style={{
                  height: '75vh',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.1))',
                  animation: 'float 8s ease-in-out infinite'
                }}
              />
            </Box>
          </Grid>

          {/* Login Box */}
          <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(12px)',
                borderRadius: 4,
                p: 4,
                minHeight: '420px',
                width: { xs: '90%', sm: '80%', md: '400px' },
                boxShadow: '0 15px 40px rgba(0,0,0,0.12)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                border: '1px solid rgba(255,255,255,0.3)',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '4px',
                  background: 'linear-gradient(90deg, #6C63FF, #FF6584, #00BFA6)',
                  backgroundSize: '200% 200%',
                  animation: 'gradientShift 3s ease infinite'
                },
                '&:hover': {
                  transform: 'translateY(-5px)',
                  transition: 'transform 0.3s ease',
                  boxShadow: '0 20px 50px rgba(0,0,0,0.15)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              <form onSubmit={formik.handleSubmit}>
                <Box textAlign="center" mb={3}>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, rgba(108, 99, 255, 0.1), rgba(255, 255, 255, 0.3))',
                      boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
                      mb: 2,
                      border: '1px solid rgba(255,255,255,0.3)'
                    }}
                  >
                    <img
                      src={knn}
                      alt="Logo"
                      style={{
                        height: '70px',
                        filter: 'drop-shadow(0 5px 10px rgba(0,0,0,0.1))'
                      }}
                    />
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: '#333',
                      textShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      letterSpacing: '0.5px'
                    }}
                  >
                    CSJMU Library Kanpur
                  </Typography>
                </Box>

                {/* Username */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: 2,
                    px: 2,
                    mb: 2,
                    transition: 'all 0.3s ease',
                    '&:focus-within': {
                      borderColor: '#6C63FF',
                      boxShadow: '0 0 0 2px rgba(108, 99, 255, 0.2)'
                    }
                  }}
                >
                  <FontAwesomeIcon
                    icon={faUser as any}
                    style={{
                      marginRight: 8,
                      color: '#6C63FF',
                      opacity: 0.7
                    }}
                  />
                  <input
                    className="LoginInput"
                    type="text"
                    name="useR_ID"
                    id="useR_ID"
                    placeholder="Username"
                    required
                    value={formik.values.useR_ID}
                    onChange={formik.handleChange}
                    style={{
                      flex: 1,
                      padding: '12px 8px',
                      border: 'none',
                      outline: 'none',
                      fontSize: '16px',
                      background: 'transparent',
                      color: '#333',
                    }}
                  />
                </Box>

                {/* Password */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: 2,
                    px: 2,
                    mb: 3,
                    transition: 'all 0.3s ease',
                    '&:focus-within': {
                      borderColor: '#6C63FF',
                      boxShadow: '0 0 0 2px rgba(108, 99, 255, 0.2)'
                    }
                  }}
                >
                  <FontAwesomeIcon
                    icon={faLock as any}
                    style={{
                      marginRight: 8,
                      color: '#6C63FF',
                      opacity: 0.7
                    }}
                  />
                  <input
                    className="LoginInput"
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Password"
                    required
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    style={{
                      flex: 1,
                      padding: '12px 8px',
                      border: 'none',
                      outline: 'none',
                      fontSize: '16px',
                      background: 'transparent',
                      color: '#333'
                    }}
                  />
                </Box>

                {/* Buttons */}
                <Box
                  display="flex"
                  justifyContent="center"
                  gap={2}
                  sx={{
                    mt: 3
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={loading}
                    sx={{
                      px: 4,
                      borderRadius: 2,
                      background: 'linear-gradient(135deg, #6C63FF, #8E85FF)',
                      boxShadow: '0 4px 15px rgba(108, 99, 255, 0.3)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #5B52E0, #7D74FF)',
                        boxShadow: '0 6px 20px rgba(108, 99, 255, 0.4)'
                      },
                      transition: 'all 0.3s ease',
                      minWidth: '120px',
                      height: '45px'
                    }}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => formik.resetForm()}
                    sx={{
                      px: 4,
                      borderRadius: 2,
                      borderColor: '#FF6584',
                      color: '#FF6584',
                      '&:hover': {
                        background: 'rgba(255, 101, 132, 0.1)',
                        borderColor: '#FF4D6D'
                      },
                      minWidth: '120px',
                      height: '45px'
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </form>
            </Box>
          </Grid>
        </Grid>

        <ToastApp />
      </Box>
    </>
  );
}

export default LoginPage;
